import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import * as XLSX from "xlsx";
const BomTable = ({ bom }) => {
    function lastName(s) {
        return s
            .split(" ")
            .map((word) => {
            if (word === "FramE")
                return "Frame";
            // Replace all occurrences of "PrelaM" within the word.
            return word.replace(/PrelaM/g, "Prelam");
        })
            .join(" ");
    }
    const handleDownload = () => {
        const data = bom.map((item) => ({
            Component: lastName(item.name),
            Qty: item.quantity,
            Price: item.price,
            Specifications: item.description,
        }));
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "BOM");
        XLSX.writeFile(workbook, "bom.xlsx");
    };
    return (_jsxs("div", { children: [_jsxs("div", Object.assign({ style: {
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                } }, { children: [_jsx("div", { children: _jsx("h1", Object.assign({ className: "mb-2" }, { children: "BOM:" })) }), _jsx("div", { children: _jsx("button", Object.assign({ onClick: handleDownload }, { children: "Download as Excel" })) })] })), _jsxs("table", { children: [_jsx("thead", { children: _jsxs("tr", Object.assign({ className: "text-left border" }, { children: [_jsx("th", Object.assign({ className: "px-4 py-2" }, { children: "Component" })), _jsx("th", Object.assign({ className: "px-4 py-2" }, { children: "Quantity" })), _jsx("th", Object.assign({ className: "px-4 py-2" }, { children: "Price" })), _jsx("th", Object.assign({ className: "px-4 py-2" }, { children: "Specifications" }))] })) }), _jsx("tbody", Object.assign({ className: "border" }, { children: bom === null || bom === void 0 ? void 0 : bom.map((item) => (_jsxs("tr", Object.assign({ className: "border" }, { children: [_jsx("td", Object.assign({ className: "px-4 py-1" }, { children: lastName(item.name) })), _jsx("td", Object.assign({ className: "px-4 py-1" }, { children: item.quantity })), _jsx("td", Object.assign({ className: "px-4 py-1" }, { children: item.price })), _jsx("td", Object.assign({ className: "px-4 py-1" }, { children: item.description }))] }), item.name))) }))] })] }));
};
export default BomTable;
